import { fetchApi } from "../utils/fetch-api";
export class AdminApi {
  static async sendNotification(payload) {
    let headers = {};
    payload.type === "multipart"
      ? (headers["Content-Type"] = "multipart/form-data")
      : (headers = {});
    try {
      const data = await fetchApi({
        url: "/api/v1/admin/notification",
        options: {
          method: "POST",
          headers,
        },
        payload: payload.values,
      });
      return data;
    } catch (error) {
      throw error;
    }
  }

  static async getNotification(id) {
    let headers = {};

    try {
      const data = await fetchApi({
        url: `/api/v1/notification/${id}`,
        options: {
          method: "GET",
          headers,
        },
      });
      console.log(data);
      return data;
    } catch (error) {
      throw error;
    }
  }
}
